package one.healthium.ui.common.message

import dev.gitlive.firebase.FirebaseException
import dev.gitlive.firebase.auth.FirebaseAuthEmailException
import dev.gitlive.firebase.auth.FirebaseAuthInvalidCredentialsException
import loco.ERROR_INVALID_CREDENTIALS
import one.healthium.loco.LString
import one.healthium.loco.asLString
import one.healthium.ui.common.event_producer.EventProducer

class UiMessageManager {

    private val eventProducer = EventProducer<UiMessage>()

    val latestMessage = eventProducer.events

    fun add(message: UiMessage) {
        eventProducer.trigger(message)
    }

    fun consume(message: UiMessage) {
        eventProducer.consume(message)
    }
}

data class UiMessage(
    val key: String? = null,
    val title: LString? = null,
    val message: LString,
) {
    companion object {

        fun throwable(throwable: Throwable): UiMessage {
            val message = when (throwable) {
                is FirebaseAuthEmailException,
                is FirebaseAuthInvalidCredentialsException -> loco.Res.string.ERROR_INVALID_CREDENTIALS.asLString()

                is FirebaseException -> {
                    val iosErrorMessage = throwable.iosErrorMessage()
                    if (!iosErrorMessage.isNullOrEmpty()) {
                        iosErrorMessage.asLString()
                    } else {
                        (throwable.message ?: throwable.toString()).asLString()
                    }
                }

                else -> (throwable.message ?: throwable.toString()).asLString()
            }
            return UiMessage(message = message)
        }
    }
}

// https://github.com/GitLiveApp/firebase-kotlin-sdk/issues/442
// https://github.com/GitLiveApp/firebase-kotlin-sdk/issues/492
private val regex = Regex("""(?s)"NSLocalizedDescription"\s*:\s*"((?:\\.|[^"\\])*)"""")

private fun unescapeCommon(s: String): String =
    Regex("""\\(.)""").replace(s) { m ->
        when (m.groupValues[1][0]) {
            'n' -> "\n"
            't' -> "\t"
            'r' -> "\r"
            '"' -> "\""
            '\\' -> "\\"
            else -> m.value
        }
    }

// Example usage inside throwable(...) where you parse the captured group:
fun FirebaseException.iosErrorMessage() = this.message
    ?.let { raw -> regex.find(raw)?.groups?.get(1)?.value }
    ?.let { unescapeCommon(it) }